module.exports = __webpack_public_path__ + "static/media/food-court-ramen-front.84a6c2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenes/food-court-ramen-front.png
// module id = 179
// module chunks = 0